module.exports = __webpack_public_path__ + "img/shape-b.a64f0037.png";